import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import { ArrowForward, ArrowBack } from "@mui/icons-material";
import "./Careers.css";

const jobListings = [
  {
    title: "Software Engineer",
    location: "Remote / San Francisco, CA",
    description:
      "We are looking for passionate software engineers to join our team. You will be working with cutting-edge technologies and solving real-world problems.",
    qualifications: [
      "Proven experience with JavaScript, React, and Node.js.",
      "Strong problem-solving skills and ability to work in a team environment.",
      "Experience with cloud computing platforms (AWS, Google Cloud, Azure).",
    ],
  },
  {
    title: "Product Manager",
    location: "New York, NY",
    description:
      "As a Product Manager, you will lead the strategy and execution of our product development roadmap. Collaborating with cross-functional teams, you will ensure that our products meet market demands.",
    qualifications: [
      "Proven experience in product management and delivering successful products.",
      "Strong communication and organizational skills.",
      "Experience with Agile methodologies.",
    ],
  },
  {
    title: "UI/UX Designer",
    location: "Remote / New York, NY",
    description:
      "We are seeking a creative UI/UX designer who is passionate about delivering intuitive and user-friendly designs for our products.",
    qualifications: [
      "Experience with wireframing, prototyping, and visual design tools (Figma, Sketch, Adobe XD).",
      "Strong understanding of user-centered design principles.",
      "Ability to collaborate with developers and product teams to deliver high-quality designs.",
    ],
  },
  {
    title: "Data Scientist",
    location: "Chicago, IL",
    description:
      "As a Data Scientist, you will work with large datasets, building models and analyzing data to inform business decisions.",
    qualifications: [
      "Proven experience in data analysis, machine learning, and statistical modeling.",
      "Strong knowledge of Python, R, and SQL.",
      "Experience with cloud-based data processing tools (AWS, Google Cloud).",
    ],
  },
  {
    title: "Marketing Manager",
    location: "Los Angeles, CA",
    description:
      "As a Marketing Manager, you will oversee the company's marketing strategies, including digital marketing and brand management.",
    qualifications: [
      "Proven experience in marketing and brand management.",
      "Strong leadership and project management skills.",
      "Experience with SEO, SEM, and digital advertising.",
    ],
  },
  {
    title: "Golang Developer",
    location: "Marathahalli, Bangalore",
    description:
      "We are looking for a Golang Developer with 5+ years of experience to join our team and work on cutting-edge projects in a hybrid work environment.",
    qualifications: [
      "5+ years of experience in Golang development.",
      "Strong understanding of distributed systems and microservices.",
      "Experience with cloud platforms and DevOps practices.",
    ],
  },
  {
    title: "Siebel Developer",
    location: "Remote",
    description:
      "We are seeking an experienced Siebel Developer (10-15 years) for a freelance opportunity to design, configure, and implement Siebel solutions.",
    qualifications: [
      "10-15 years of Siebel development experience.",
      "Strong background in Siebel tools and development.",
      "Experience with Siebel configuration and customizations.",
    ],
  },
  {
    title: "Technical Program Manager",
    location: "Bangalore, India (On-site/Hybrid)",
    description:
      "We are looking for a Technical Program Manager with 6+ years of experience to lead high-impact projects, collaborate with senior engineers, and ensure the successful delivery of software solutions.",
    qualifications: [
      "7+ years of experience in Software Development, with 5+ years in a Program Manager role.",
      "Hands-on experience with Java, Linux, and RDBMS.",
      "Experience in Agile methodologies and managing stakeholder expectations.",
    ], 
  },
  {
    title: "Mid-Level Node.js Developer",
    location: "Whitefield, Bangalore",
    description:
      "We are looking for a Mid-Level Node.js Developer (5+ years) to develop, deploy, and maintain scalable microservices and RESTful APIs, with expertise in cloud environments like AWS and DevOps practices.",
    qualifications: [
      "5+ years of experience in Node.js development.",
      "Expertise in designing and developing microservices and REST APIs.",
      "Experience with queuing mechanisms like Kafka or RabbitMQ.",
    ],
  },
  {
    title: "Ruby on Rails Developer",
    location: "Hyderabad, India",
    description:
      "We are seeking a Mid-Level Ruby on Rails Developer (5+ years) to design and develop web applications and microservices, with strong experience in testing, databases, and Dockerization.",
    qualifications: [
      "5+ years in software engineering, with at least 1.5+ years in Ruby on Rails.",
      "Experience with MongoDB, PostgreSQL, and MySQL.",
      "Familiarity with ReactJS and other front-end technologies.",
    ],
  },
];

const Careers = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedJob, setSelectedJob] = useState(null);

  // Auto-rotate every 10 seconds
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prevIndex) => (prevIndex + 3) % jobListings.length);
  //   }, 10000);
  //   return () => clearInterval(interval);
  // }, []);

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 3) % jobListings.length);
  };

  const handlePrevClick = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 3 + jobListings.length) % jobListings.length
    );
  };

  const handleJobClick = (job) => {
    setSelectedJob(job);
  };

  const handleBackClick = () => {
    setSelectedJob(null);
  };

  return (
    <div className="careers-container">
      <h1 className="careers-title">Careers at Our Company</h1>

      {selectedJob ? (
        <div className="job-details">
          <div className="job-details-header">
            <h2>{selectedJob.title}</h2>
            <button onClick={handleBackClick} className="back-button">
              Back to Job Listings
            </button>
          </div>
          <div className="job-description">
            <p><strong>Location:</strong> {selectedJob.location}</p>
            <p>{selectedJob.description}</p>
            <h3>Qualifications:</h3>
            <ul>
              {selectedJob.qualifications.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <button className="apply-button">Apply Now</button>
          </div>
        </div>
      ) : (
        <div className="carousel-container">
          <IconButton onClick={handlePrevClick}>
            <ArrowBack />
          </IconButton>

          <div className="job-listings">
            {jobListings.slice(currentIndex, currentIndex + 3).map((job, index) => (
              <div
                key={index}
                className="job-card"
                onClick={() => handleJobClick(job)}
              >
                <h2>{job.title}</h2>
                <p>{job.location}</p>
                <p>{job.description}</p>
                <button className="view-details-button">View Details</button>
              </div>
            ))}
          </div>

          <IconButton onClick={handleNextClick}>
            <ArrowForward />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default Careers;
